import { theme } from '@common/theme'
import { Box, Typography } from '@mui/material'
import { Upload } from '@mui/icons-material'


export default function MessageEditorDropFilesOverlay() {
    return (
        <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 10,
            backgroundColor: 'rgba(59, 130, 246, 0.2)', // blue-500/20
            backdropFilter: 'blur(4px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '8px',
            pointerEvents: 'none'
        }}>
            <Box sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.95)', // white/95
                padding: theme.spacing(3),
                borderRadius: '12px',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', // shadow-xl
                border: '2px solid #60a5fa', // border-blue-400
                transform: 'scale(1.1)',
                animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: theme.spacing(1)
            }}>
                <Upload sx={{ 
                    width: '40px', 
                    height: '40px', 
                    color: '#3b82f6', // text-blue-500
                    marginBottom: theme.spacing(1)
                }} />
                <Typography sx={{
                    fontSize: '18px',
                    fontWeight: 600,
                    color: '#1d4ed8', // text-blue-700
                    textAlign: 'center',
                    whiteSpace: 'nowrap'
                }}>
                    Drop files to attach
                </Typography>
            </Box>
        </Box>
    )
}